// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1525":"e0e5d00f8f497c0a0ab1","6616":"4dd300638cd8885c6394"}[chunkId] + ".css";
};